import { render, staticRenderFns } from "./Form48.vue?vue&type=template&id=6599c920&scoped=true"
import script from "./Form48.vue?vue&type=script&lang=ts"
export * from "./Form48.vue?vue&type=script&lang=ts"
import style0 from "@/styles/_pdf.scss?vue&type=style&index=0&id=6599c920&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6599c920",
  null
  
)

export default component.exports